const DEFAULT_PATH = '/'

function getCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`
  const parts = document.cookie ? document.cookie.split('; ') : []
  for (const part of parts) {
    if (part.startsWith(prefix)) {
      return decodeURIComponent(part.slice(prefix.length))
    }
  }
  return undefined
}

function setCookie(name, value, options = {}) {
  const path = options.path || DEFAULT_PATH
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}`

  if (options.expires instanceof Date) {
    cookie += `; expires=${options.expires.toUTCString()}`
  } else if (typeof options.expires === 'number') {
    const expires = new Date()
    expires.setTime(expires.getTime() + options.expires * 86400000)
    cookie += `; expires=${expires.toUTCString()}`
  }

  document.cookie = cookie
}

function removeCookie(name, options = {}) {
  setCookie(name, '', {
    path: options.path || DEFAULT_PATH,
    expires: new Date(0)
  })
}

const cookieStore = {
  load: getCookie,
  save: setCookie,
  remove: removeCookie,
}

export default cookieStore
